import { Box } from "@mui/material";
import { Groups } from "../../../components/groups/Groups";
import { InstrumentDimensionsScores } from "./InstrumentDimensionsScores";
import { psyEvaluationsCreateGroupsOptions } from "../psyEvaluationsOptions";
import { buildGroupedFields } from "../../../utils/buildGroupedFields";
import { useInstrumentResponseCreateForm } from "../useInstrumentResponseCreateForm";

export const InstrumentResponseCreateForm = () => {
	const { entityForm, formatedFields, dimensions, dimensionsStatus, instrumentId, onSubmit } =
		useInstrumentResponseCreateForm();

	if (!entityForm) return null;

	return (
		<Box
			component="form"
			id="instruments_responses"
			onSubmit={(e) => {
				e.preventDefault();
				entityForm.handleSubmit(onSubmit)(e);
			}}
			sx={{ width: "100%", backgroundColor: "#fff" }}
		>
			<Groups
				item={null}
				fields={buildGroupedFields(formatedFields, "Avaliação")}
				entityForm={entityForm}
				type="create"
				groupsOptions={psyEvaluationsCreateGroupsOptions}
				bottomPadding={0}
			/>
			{instrumentId && (
				<InstrumentDimensionsScores
					dimensions={dimensions}
					entityForm={entityForm}
					isLoading={dimensionsStatus === "loading"}
				/>
			)}
		</Box>
	);
};
